import React from 'react'
import Link from 'gatsby-link'

//  Components
import ThemeLink from '../ThemeLink/ThemeLink.js'
import Button from '../Button/Button.js'

//  Styles
import styles from './KeyThemes.module.scss'

const KeyThemes = ( props ) => (
  <div>
    <div className={ styles.key__themes }>
      <h2 className={ styles.key__themes__title }>Highlights</h2>
      <ul className={ styles.key__themes__list }>
        { props.data.allThemesJson.edges.map((node) =>
          <li key={node.node.theme_id}>
            <ThemeLink
            node={node.node}
            className="theme__link__large"/>
          </li>
        )}
      </ul>
    </div>
    <div className={ styles.key__themes__conclusion }>
      <h2><Link to="/conclusion">Conclusion</Link></h2>
      <div className={ styles.key__themes__conclusion__content }>
        <p>The 2020 Scorecard offers the latest available federal data on the state of the
          U.S. health system before it headed into the most severe public health crisis and
          economic collapse in modern times. It also highlights health system weaknesses
          that have left the U.S. far less prepared than other high-income countries to cope
          with public health threats like COVID-19. These weaknesses include:
        </p>
        <ul>
          <li>a health care delivery system that is highly unequal in its care of people of
            color and those with low and moderate incomes.</li>
          <li>an insurance system that still leaves millions without coverage.</li>
          <li>exorbitant commercial insurance prices that fuel growth in health spending
            and expose people to high premiums and deductibles, even as many make
            wage concessions to keep their employer benefits.</li>
          <li>an inadequate primary care system.</li>
          <li>declining life expectancy.</li>
        </ul>

        <Button
          to="/conclusion"
          text="Keep Reading"
          className="button__primary__reversed"
          />
      </div>
    </div>
  </div>
)

export default KeyThemes



// WEBPACK FOOTER //
// ./src/components/KeyThemes/KeyThemes.js